export class GetSellerTradeDataTransactionsError extends Error {}
